import React, { useContext } from 'react';
import { useLocation } from '@app/utils';
import { useForm } from 'react-hook-form';
import {
  Container,
  InnerContainer,
  Heading,
  Row,
  RowItem,
  ErrorMessage,
  Footer,
  CancelButton,
  ButtonContainer,
  SavingIndicator,
} from '@app/modules/change-password/change-password-components';
import { Password, Button, Toast } from '@app/components';
import { changePassword } from '@app/auth/firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '@app/providers';
import { getDefaultUrl } from '@app/routes/routes-helper';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

export default function ChangePassword() {
  const { navigate } = useLocation();
  const { userInfo } = useContext(AuthContext);
  const defaultUrl: string = getDefaultUrl(userInfo);
  const { register, errors, handleSubmit, watch, reset } = useForm();
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)[a-zA-Z0-9\S]{6,20}$/;
  const [showToast, setShowToast] = React.useState(false);
  const [showErrorPage, SetShowErrorPage] = React.useState(false);
  const [passworderror, updatePassworderror] = React.useState('');
  const [saving, updateSaving] = React.useState(false);

  function onSubmit(data: any) {
    updatePassworderror('');
    updateSaving(true);
    changePassword(data.current_password, data.password)
      .then((result: any) => {
        if (result.code === 'auth/wrong-password') {
          updatePassworderror('Incorrect Password');
        }
        if (result.success) {
          setShowToast(true);
          updateSaving(false);
          setTimeout(() => {
            setShowToast(false);
            reset();
            navigate(defaultUrl);
          }, 1000);
        } else {
          updateSaving(false);
        }
      })
      .catch((error: any) => {
        updateSaving(false);
        SetShowErrorPage(true);
      });
  }

  function onChange(data: any) {
    if (data.target.name === 'current_password' && data.target.value) {
      updatePassworderror('');
    }
  }

  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <>
          <Container>
            <Toast
              message="Password Updated Successfully"
              showToast={showToast}
              onClose={() => setShowToast(false)}
            />
            <InnerContainer>
              <Heading>Change Password</Heading>
              <form
                onSubmit={handleSubmit(onSubmit)}
                onChange={onChange}
                autoComplete="off">
                <Row>
                  <RowItem>
                    <Password
                      label="Current Password"
                      name="current_password"
                      placeholder="Enter Current Password"
                      register={register({ required: true })}
                    />
                    {((errors.current_password &&
                      errors.current_password.type === 'required') ||
                      passworderror) && (
                      <ErrorMessage>
                        {passworderror
                          ? passworderror
                          : 'Please enter current password'}
                      </ErrorMessage>
                    )}
                  </RowItem>
                </Row>
                <Row>
                  <RowItem>
                    <Password
                      label="New Password"
                      name="password"
                      register={register({
                        required: true,
                        pattern: passwordPattern,
                      })}
                      placeholder="Enter New Password"
                    />
                    {errors.password && errors.password.type === 'required' && (
                      <ErrorMessage>Please enter new password</ErrorMessage>
                    )}
                    {errors.password && errors.password.type === 'pattern' && (
                      <ErrorMessage>
                        Please enter a strong password
                      </ErrorMessage>
                    )}
                  </RowItem>
                  <RowItem>
                    <Password
                      label="Confirm Password"
                      name="confirmPassword"
                      register={register({
                        required: true,
                        validate: value => {
                          return value === watch('password');
                        },
                      })}
                      placeholder="Enter New Password Again"
                    />
                    {errors.confirmPassword &&
                      errors.confirmPassword.type === 'required' && (
                        <ErrorMessage>Please confirm password</ErrorMessage>
                      )}
                    {errors.confirmPassword &&
                      errors.confirmPassword.type === 'validate' && (
                        <ErrorMessage>Passwords did not match</ErrorMessage>
                      )}
                  </RowItem>
                </Row>
                <Footer>
                  <CancelButton onClick={() => navigate(defaultUrl)}>
                    Cancel
                  </CancelButton>
                  <ButtonContainer disabled={saving}>
                    <Button
                      type="submit"
                      variant="primary"
                      size="medium"
                      width="100%">
                      Save & Update
                    </Button>
                  </ButtonContainer>
                  {saving && (
                    <SavingIndicator>
                      <FontAwesomeIcon
                        color={'#fff'}
                        icon={faCircleNotch}
                        size="lg"
                        spin
                      />
                    </SavingIndicator>
                  )}
                </Footer>
              </form>
            </InnerContainer>
          </Container>
        </>
      )}
    </>
  );
}
